/* React */
import React from "react";

/* Ionic */
import {
  chevronBack,
  chevronForward,
} from "ionicons/icons";

/* Components */
import PrimaryFabButton from "src/components/shared/buttons/primary-fab-button/PrimaryFabButton";

/* Stylesheet */
import styles from "./PaginationContainer.module.scss";

const PaginationContainer: React.FC = () => {
  return (
    <div className={styles.pagination_container}>
      <PrimaryFabButton
        className={"small"}
        ariaLabel={"Prev-Button"}
        icon={chevronBack}
        scssProps={{
          color: "var(--ion-color-text-primary)",
          background: "transparent",
        }}
      />
      Pagination
      <PrimaryFabButton
        className={"small"}
        ariaLabel={"Next-Button"}
        icon={chevronForward}
        scssProps={{
          color: "var(--ion-color-text-primary)",
          background: "transparent",
        }}
      />
    </div>
  );
};

export default PaginationContainer;
